import { Box, Button, Card, CardContent, Dialog, DialogContent, DialogContentText, DialogTitle, IconButton, Typography } from "@mui/material";
import { ShieldWarning } from "@phosphor-icons/react";
import { useState } from "react";
import CloseIcon from '@mui/icons-material/Close';
import { ReactComponent as AlertOctogon } from "../../assets/alert-octagon.svg";

type Props = {
    onAction: () => void
}

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

const RecommendServices = ({onAction}: Props) => {

    const [warningModel, setWarningModel] = useState(false);

    const warningModelOpenHandler = () => {
        setWarningModel(true);
    }

    const warningModelCloseHandler = () => {
        setWarningModel(false);
    }

    return (
        <>
        <Card sx={{borderRadius: 1}}>
            <CardContent sx={{p:0, '&:last-child':{paddingBottom: 0}}}>
                <Typography variant="subtitle1" sx={{m:2, mb:3}}><ShieldWarning className="me-2"/>{'Recommend Services'}</Typography>
                <Button sx={{m:2, mb:1}} className="btn-forward" onClick={warningModelOpenHandler}>{'Forward Customer  to Optima'}</Button>
                <Typography variant="body2" className="fs-8" sx={{m:2, mb:3}}>{'A deleted customer cannot be restored. All data will be permanently removed.'}</Typography>
            </CardContent>
        </Card>
        <Dialog open={warningModel} onClose={warningModelCloseHandler} sx={{justifyContent: 'center'}}>
            <IconButton
            aria-label="close"
            onClick={warningModelCloseHandler}
            sx={(theme) => ({
                position: 'absolute',
                right: 8,
                top: 8,
                color: theme.palette.grey[500],
            })}
            >
            <CloseIcon />
            </IconButton>
            <DialogContent sx={{mt: 2}}>
                <Box sx={{display: 'flex', flexDirection:'column', justifyContent: 'center', alignItems: 'center'}}>
                    <AlertOctogon />
                    <Typography variant="h5" sx={{textAlign: 'center', mt: 2}}>
                    {'Forward Customer to Optima'}
                    </Typography>
                    <Typography sx={{textAlign: 'center', mt: 2}}>
                    A deleted customer cannot be restored. All data will be permanently removed.
                    </Typography>
                    <Box sx={{mt:3}}>
                        <Button className="option-primary-button" onClick={warningModelCloseHandler}>Retain Customer</Button>
                        <Button className="option-red-button ms-3" onClick={warningModelCloseHandler}>Forward Customer</Button>
                    </Box>
                </Box>
            </DialogContent>
        </Dialog>
        </>
    );
}

export default RecommendServices;